import { Box, Divider, Typography, styled } from "@mui/material"
import { extraColors } from "../../utils/theme"
import {
  WASTEWATER_CHART_COLORS,
  type WastewaterCategory,
} from "../Wastewater/wastewaterHeatmapConstants"

export const LegendContainer = styled(Box)({
  display: "flex",
  flexDirection: "column",
  width: 350,
  marginLeft: 16,
  marginTop: 16,
  flexShrink: 0,
})

export const LegendTable = styled(Box)({
  backgroundColor: extraColors.dark,
  display: "flex",
  flexDirection: "column",
  width: "100%",
  borderRadius: 6,
})

export const LegendHeader = styled(Box)<{ columns?: number }>(
  ({ columns = 2 }) => ({
    display: "grid",
    gridTemplateColumns: `50px ${"1fr ".repeat(columns - 1).trim()}`,
    alignItems: "center",
    borderBottom: `1px solid ${extraColors.dark10}`,
    backgroundColor: extraColors.translucent5,
    height: 42,
    borderTopLeftRadius: 6,
    borderTopRightRadius: 6,
  })
)

export const LegendRow = styled(Box, {
  shouldForwardProp: prop => prop !== "active",
})<{ active?: boolean; columns?: number }>(({ active, columns = 2 }) => ({
  display: "grid",
  gridTemplateColumns: `50px ${"1fr ".repeat(columns - 1).trim()}`,
  alignItems: "center",
  borderBottom: `1px solid ${extraColors.dark10}`,
  backgroundColor: active ? extraColors.translucent5 : "transparent",
  cursor: "pointer",
  height: 48,
  "&:hover": {
    backgroundColor: extraColors.translucent8,
  },
  "&:last-of-type": {
    borderBottomLeftRadius: 6,
    borderBottomRightRadius: 6,
  },
}))

export const HeaderCell = styled(Box)({
  padding: "0 8px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
})

export const Cell = styled(Box)({
  padding: "0 8px",
  display: "flex",
  alignItems: "center",
})

export const CurrentActivityChip = styled(Box)<{
  level: WastewaterCategory
}>(({ level }) => {
  const colors = WASTEWATER_CHART_COLORS[level]

  return {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "2px 8px",
    borderRadius: 2,
    backgroundColor: colors.deep,
    border: `1px solid ${colors.muted}`,
    color: colors.light,
    width: "100%",
    fontSize: 12,
    fontWeight: 600,
    textTransform: "uppercase",
  }
})

export const HelperText = styled(Typography)({
  fontFamily: "Poppins",
  fontSize: 12,
  color: extraColors.medium,
  marginTop: 12,
})

export const SearchBox = styled("input")({
  backgroundColor: extraColors.dark5,
  border: `1px solid ${extraColors.disabled}`,
  borderRadius: 2,
  padding: "8px 12px",
  color: extraColors.white,
  width: "100%",
  marginBottom: 12,
  fontSize: 14,
  fontFamily: "Poppins",
  "&:focus": {
    outline: "none",
    borderColor: extraColors.status.navyLight,
  },
})

export const TooltipContainer = styled("div")({
  position: "relative",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
})

export const TooltipContentBox = styled("div")({
  backgroundColor: "rgba(0, 0, 0, 0.7)",
  backdropFilter: "blur(8px)",
  border: `1px solid ${extraColors.dark10}`,
  borderRadius: 2,
  padding: "6px 12px",
  display: "flex",
  flexDirection: "column",
  gap: 6,
  minWidth: 180,
  maxWidth: 220,
})

export const ItemContainer = styled(Box)({
  display: "flex",
  flexDirection: "column",
  gap: 6,
  width: "100%",
})

export const ItemHeader = styled(Box)({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  width: "100%",
})

export const InfoRow = styled(Box)({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  width: "100%",
})

// Tooltip-specific styled components
export const ActivityChip = styled(Box)<{ level: WastewaterCategory }>(({
  level,
}) => {
  const colors = WASTEWATER_CHART_COLORS[level]

  return {
    backgroundColor: colors.deep,
    border: `1px solid ${colors.muted}`,
    borderRadius: 2,
    color: colors.light,
    padding: "1px 6px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: 10,
    fontFamily: "Poppins",
    fontWeight: 600,
    width: "100%",
    textTransform: "capitalize",
  }
})

export const StyledDivider = styled(Divider)({
  borderColor: extraColors.dark10,
  width: "100%",
})
